export function getMaxHeight(count, isOpen) {
  if (!isOpen || count === 0) {
    return undefined;
  }

  return `${count * 2.5 + 2}rem`;
}

export function countVisibleChild(rootId, visibleItems) {
  return visibleItems.count((item) => item.get('rootIds')?.some((id) => id === rootId));
}
